import { usePostHog } from '@posthog/react'
import { useEffect } from 'react'
import { applyAnalyticsConsent } from '~/lib/consent'
import { buildConsentConfig } from '~/lib/consent-config'

let started = false

/** Shows the consent banner and tells PostHog what the visitor chose. Renders nothing itself. */
export function ConsentManager() {
  const posthog = usePostHog()

  useEffect(() => {
    if (started) return
    started = true
    void import('vanilla-cookieconsent').then(({ run, validConsent }) =>
      run(buildConsentConfig((granted) => applyAnalyticsConsent(posthog, granted))).then(() => {
        // PostHog remembers a choice by itself; with no choice of ours on record it must not
        if (!validConsent() && posthog.get_explicit_consent_status() !== 'pending') posthog.reset()
      }),
    )
  }, [posthog])

  return null
}
